import React, { useState } from "react";
import "../../App.css";
import { routes } from "../../config/utilities/utils.constant";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import shareYourIdeasWithUs from "../../assets/images/share-your-ideas-with-us.webp";
// import "./index.css";
function FAQSection({
  faqData,
  heading = "Frequently Asked Questions",
  fontSize = "text-base md:text-lg",
  headingFontSize = "text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] ",
  setStyle = false,
}) {
  const [activeCategory, setActiveCategory] = useState("General FAQs");
  const [activeIndex, setActiveIndex] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const filteredFaqs = faqData[activeCategory] || [];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    setActiveIndex(null); // Reset active accordion when category changes
  };

  return (
    <section className="space-y-0 lg:space-y-0 flex flex-col lg:flex-row lg:space-x-0">
      <div className=" lg:w-5/12 flex flex-col  relative">
        <div className="w-full py-6 space-y-3 ">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className={`${headingFontSize} text-center lg:text-start font-bold text-dark font-butler`}
          >
            {heading}
          </motion.h2>
          <div className="w-10/12 md:w-5/12 mx-auto lg:hidden ">
            <img
              src={shareYourIdeasWithUs}
              alt="A colorful bulb representing creative ideas and the branding of Apptalyst."
              className=" w-full "
              loading="lazy"
              width={20}
              height={20}
            />
          </div>
        </div>

        <div className="w-full   space-y5 hidden  lg:block h-max pr-14">
          <p className="flex text-base leading-[1.625rem] items-center text-dark font-medium">
            We’re always happy to answer any particular questions you may have.
          </p>
          <div className=" h-full flex flex-col">
            <Link
              to={routes.CONTACTUS}
              aria-label="Internal link to Contact Us page"
            >
              <button
                title="Contact Apptalyst Team"
                className="order-4 w-full md:w-auto mt-4 px-6 py-3 bg-[#FFC067] text-dark font-bold rounded shadow   text-base md:text-lg hover:bg-[#df73ff] hover:text-dark  transition ease-in duration-300"
              >
                Contact Us
              </button>
            </Link>
          </div>
        </div>
        {/* <div className="w-12/12  xl:w-9/12  2xl:w-8/12  ml-auto mt-auto ">
      <img src={shareYourIdeasWithUs} alt="" className=" w-full " />
    </div> */}
        <div
          className={`w-12/12 ${faqData.length === 7 ? "lg:w-8/12" : "lg:w-9/12 xl:w-8/12 2xl:w-6/12"}       absolute bottom-0  right-0 hidden lg:block`}
        >
          <img
            src={shareYourIdeasWithUs}
            alt="A colorful bulb representing creative ideas and the branding of Apptalyst."
            width={20}
            height={20}
            className=" w-full "
            loading="lazy"
          />
        </div>
      </div>

      <div className="w-full lg:w-7/12  relative">
        <div className=" bg-white rounded-md  overflow-hidden shadow-lg md:px-4  ">
          <div className="lg:col-span-4 bg-white rounded-md overflow-hidden  px-4 py-4">
            <ul className="divide-y divide-gray-100 space-y-4">
              {faqData.map((faq, index) => (
                <li
                  key={faq.id}
                  className={`px-2 md:px-6 py-4 ${
                    activeIndex === index
                      ? "bg-gradient-to-br bg-[#f3ebfa] text-dark "
                      : "bg-gray-50 text-dark"
                  } rounded-lg `}
                >
                  <div
                    className={`flex justify-between items-start w-full cursor-pointer ${
                      activeIndex === index ? "mb-2" : ""
                    }`}
                    onClick={() => toggleAccordion(index)}
                  >
                    <div className="flex items-center md:space-x-3 px-2 md:px-0 w-full">
                      <span
                        className={`font-semibold text-5xl hidden sm:block ${
                          activeIndex === index ? "text-dark" : "text-gray-300"
                        }`}
                      >
                        0{index + 1}
                      </span>
                      <div className="flex justify-between w-full space-x-1">
                        <h3
                          className={` font-semibold text-lg ${
                            activeIndex === index ? "text-dark" : "text-dark"
                          }`}
                        >
                          {faq.question}
                        </h3>
                        <span
                          className={`text-lg text-gray-500 ${
                            activeIndex === index ? "rotate180" : ""
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 transition-transform duration-300"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d={
                                activeIndex === index
                                  ? "M5 12h14"
                                  : "M12 6v6m0 0v6m0-6h6m-6 0H6"
                              }
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* {activeIndex === index && (
              <div className="mt-6 text-dark  px-2 md:px-0">
                <p className="whitespace-pre-line">{faq.answer}</p>
              </div> 
            )} */}
                  <div
                    className={`overflow-hidden transition-all duration-500 ease-in-out ${
                      activeIndex === index
                        ? "max-h-[100vh] opacity-100 mt-6"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="px-2 md:px-0 text-dark">
                      {Array.isArray(faq.answer) ? (
                        <div>
                          {faq.answer.map((item, index) => (
                            <div key={index} className="space-y-10">
                              {item.type === "paragraph" && (
                                <p
                                  className={`mb-2 text-base leading-[1.625rem]`}
                                >
                                  {item.content}
                                </p>
                              )}
                              {item.type === "list" && (
                                <ul className=" list-disc ml-5 space-y-2">
                                  {item.list.map((listItem, listIndex) => {
                                    const [boldText, restText] =
                                      listItem.split(":");

                                    return (
                                      <li
                                        key={listIndex}
                                        className={`text-base leading-[1.625rem]`}
                                      >
                                        <span className="font-bold">
                                          {boldText}:
                                        </span>{" "}
                                        <span
                                         >
                                          {restText}
                                        </span>
                                      </li>

                                      // <li key={listIndex} className="text-base md:text-[15px]" >{listItem}</li>
                                    );
                                  })}
                                </ul>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p
                          className={`whitespace-pre-line text-base leading-[1.625rem]`}
                        >
                          {faq.answer}
                        </p>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="w-full  space-y-5 sm:space-y-0 sm:px-8   lg:hidden sm:flex justify-between items-center pt-16 md:pt-16 px-4 md:px-0 ">
        <p className="flex  text-dark justify-center text-center sm:text-center text-base leading-[1.625rem] font-medium sm:w-9/12  ">
          We’re always happy to answer any particular questions you may have.
        </p>

        <div className="">
          <Link
            to={routes.CONTACTUS}
            aria-label="Internal link to Contact Us page"
          >
            <button className=" w-full  px-6 py-3 bg-[#FFC067] text-dark font-bold rounded shadow  text-base hover:bg-[#DF73FF]  transition ease-in duration-300">
              Contact Us
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
